import { createApiRef } from '@backstage/core-plugin-api';
import type { CompoundEntityRef } from '@backstage/catalog-model';

// Result of a successful write. `dryRun` echoes the backend's keyVault.dryRun so
// the UI can say "validated but not written" in local/dev mode. No secret value
// is ever returned.
export type SetSecretResult = {
  ok: true;
  secretName: string;
  dryRun: boolean;
  version: string | null;
};

export interface KeyVaultApi {
  // Existing secret NAMES only (never values). May reject if listing is
  // disabled server-side (keyVault.enableList=false) or the vault is unreachable.
  listSecretNames(entityRef: CompoundEntityRef): Promise<string[]>;
  // Upsert one secret (write-only). An existing name is overwritten.
  setSecret(
    entityRef: CompoundEntityRef,
    secretName: string,
    secretValue: string,
  ): Promise<SetSecretResult>;
}

export const keyVaultApiRef = createApiRef<KeyVaultApi>({
  id: 'plugin.key-vault.api',
});
